var _g;
import * as React from "react";
var SvgChartNocheck = function SvgChartNocheck(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.273438,17.374023l-1.646973-1.647461L10.353027,12L6.626465,8.273438l1.646973-1.646973L12,10.353027l3.726562-3.726562 l1.647461,1.646973L13.647461,12l3.726562,3.726562l-1.647461,1.647461L12,13.647461L8.273438,17.374023z"
  })));
};
export default SvgChartNocheck;